import { useAuth } from "@/core/auth/hooks/useAuth";
import { useCurrentBusiness } from "@/features/business/hooks/useCurrentBusiness";
import { ErrorState } from "@/shared/components/ui/ErrorState";
import { LoadingSpinner } from "@/shared/components/ui/LoadingSpinner";
import { Page, PageContent } from "@/shared/components/ui/Page";
import { PageHeader } from "@/shared/components/ui/PageHeader";
import { ProfileEditor } from "../components/ProfileEditor";
import { useCurrentProfile } from "../hooks/useCurrentProfile";

export function ProfilePage() {
  const { user } = useAuth();
  const { profile, isLoading, error, refetch } = useCurrentProfile();
  const { business, location, loading } = useCurrentBusiness();

  if (!isLoading && !loading && !error && profile && business && location) {
    return (
      <ProfileEditor
        key={`${profile.id}:${business.id}:${location.id}`}
        profile={profile}
        business={business}
        location={location}
        email={user?.email}
      />
    );
  }

  return (
    <Page>
      <PageHeader title="Profile" description="Manage your profile, business and location details." />
      <PageContent>
        {isLoading || loading ? <LoadingSpinner message="Loading your profile..." /> : error ? (
          <ErrorState message={error.message} onRetry={() => void refetch()} />
        ) : (
          <ErrorState message="A profile, business and location are required to manage your details." />
        )}
      </PageContent>
    </Page>
  );
}
